'use client';

import { Consumer } from './Consumer';
import { Provider as CtxProvider } from './Provider';

export * from './Consumer';

type ContextProvider = typeof CtxProvider & {
  Consumer: typeof Consumer;
};

Object.assign( CtxProvider, {
  Consumer,
} );

export const Provider = CtxProvider as ContextProvider;
